import { Card, Button } from "@emanprague/ppaskit";
import OmniAuthButton from "components/OmniAuthButton";
import type SimplePortalSettings from "entities/simplePortalSettings";
import type User from "entities/user";
import { observer } from "mobx-react-lite";
import React from "react";
import iconGoogle from "../OmniAuthButton/google.svg";
import iconSeznam from "../OmniAuthButton/seznam.svg";
import styles from "./style.module.scss";

export interface OmniAuthStatusCardProps {
  translate: (key: string) => string;
  user: User;
  googleLoginSetting: SimplePortalSettings;
  seznamLoginSetting: SimplePortalSettings;
  unlinkOmniAuth: () => void;
}

export const OmniAuthStatusCard = observer(
  ({ translate, user, googleLoginSetting, seznamLoginSetting, unlinkOmniAuth }: OmniAuthStatusCardProps) => {
    const icon = user.omniAuthProvider === "seznam_oauth2" ? iconSeznam : iconGoogle;

    if (!googleLoginSetting?.active && !seznamLoginSetting?.active) {
      return null;
    }

    return (
      <Card>
        <Card.Body>
          <div className={styles.omniAuthCard}>
            <h2 className="display-4 mb-0">{translate("omniauth.title")}</h2>
            {user.omniAuthEnabled ? (
              <div className={styles.omniAuthContent}>
                <div>
                  <img src={icon} width={20} height={20} alt="" className="mr-2" />
                  {user.omniAuthEmail}
                </div>

                <Button variant="danger" size="sm" onClick={unlinkOmniAuth}>
                  {translate("omniauth.remove")}
                </Button>
              </div>
            ) : (
              <div className={styles.omniAuthContent}>
                <OmniAuthButton
                  provider="google"
                  text={translate("omniauth.link_google")}
                  origin="create_link"
                  setting={googleLoginSetting}
                />
                <OmniAuthButton
                  provider="seznam"
                  text={translate("omniauth.link_seznam")}
                  origin="create_link"
                  setting={seznamLoginSetting}
                />
              </div>
            )}
          </div>
        </Card.Body>
      </Card>
    );
  }
);
